import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialInstitutionItemCategoryState: Dtos.TrialInstitutionItemCategory & IRegistrationFormState = {
    trialInstitutionItemTemplateCategoryId: null,
    trialInstitutionItemTemplateCategory: null,
    trialInstitutionItems: [],
    trialInstitutionItemSummaries: [],
    saveAndReturn: null
}

export interface ITrialInstitutionItemCategoryReduxFormState {
    trialInstitutionItemTemplateCategoryId: IFieldState<number>,
    trialInstitutionItemTemplateCategory: IFieldState<Dtos.TrialInstitutionItemTemplateCategory>,
    trialInstitutionItems: IFieldState<Dtos.TrialInstitutionItem[]>,
    trialInstitutionItemSummaries: IFieldState<Dtos.TrialInstitutionItemSummary[]>
}
